<script setup lang="ts">
import {onMounted, ref} from "vue";

const props = defineProps(['googlePickerUrlGetAccounts', 'googlePickerUrlManageAccounts', 'i18n'])
const emit = defineEmits(['setActiveGoogleAccount'])
const activeGoogleAccount = ref(0)
const googleAccounts = ref([])

function changeGoogleAccount() {
    localStorage.setItem('eg-fileupload-googlephotosaccount-id', activeGoogleAccount.value)
    emit('setActiveGoogleAccount',activeGoogleAccount.value)
}

onMounted(async () => {
    await fetch(props.googlePickerUrlGetAccounts)
        .then((response) => response.json())
        .then((responseData) => {
            googleAccounts.value = responseData
        })
    const oldid = parseInt(localStorage.getItem('eg-fileupload-googlephotosaccount-id'));
    if (googleAccounts.value.some( account => account.id == oldid)) {
        activeGoogleAccount.value = oldid
    } else {
        activeGoogleAccount.value = googleAccounts.value[0].id
    }
    changeGoogleAccount()
})

</script>

<template>
  <select
    v-if="googleAccounts.length > 0"
    v-model="activeGoogleAccount"
    class="form-select"
    @change="changeGoogleAccount"
  >
    <option v-for="value in googleAccounts" :key="value.id" :value="value.id">
      {{ value.name }}
    </option>
  </select>
  <p v-else>
    {{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_NO_GOOGLE_ACCOUNTS }} <a :href="googlePickerUrlManageAccounts">{{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_MANAGE_GOOGLE_ACCOUNTS }}</a>
  </p>
</template>

<style scoped lang="less">
    p {
        margin: 20px;
    }
</style>